// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection":"VersionDE_power-ocean-collection__BISSs"};